import { UseCustomAxios } from "../../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../../util/Utils";

export function UseHomeAdvertising() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, imageState, setter) {
    let errorState = {
      url: isEmpty(state.url),
      height: isEmpty(state.height),
      width: isEmpty(state.width),
      file: isEmpty(imageState.file),
    };

    setter(errorState);

    if (errorState.url || errorState.height || errorState.width) {
      enqueueSnackbar("لطفا اطلاعات آیتم را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else if (imageState.file && errorState.file) {
      enqueueSnackbar("لطفا تصویر آیتم را وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetHomeAdvs = (landingID, callback) => {
    MyAxios.get(`Admin_HomeAdv`, {
      headers: {
        AID: landingID,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetAdvByID = (landingID, callback) => {
    MyAxios.get(`Admin_HomeAdv/${landingID}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const addAdvBox = (state, file1, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (file1) {
      data.append("Image1", file1);
    }
    MyAxios.post(`Admin_HomeAdv`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("تبلیغ با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const updateAdvBox = (state, file1, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (file1) {
      data.append("Image1", file1);
    }
    MyAxios.put(`Admin_HomeAdv`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("تبلیغ با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteAdvBox = (AdvID, callback) => {
    const data = new FormData();
    data.append("AdvID", AdvID);
    MyAxios.delete(`Admin_HomeAdv`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("تبلیغ با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addAdvItem = (state, Image, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (Image) {
      data.append("Image", Image);
    }
    MyAxios.post(`Admin_HomeAdv/Item`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("آیتم با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const updateAdvItem = (state, file, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (file) {
      data.append("Image", file);
    }
    MyAxios.put(`Admin_HomeAdv/Item`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("آیتم با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteAdvItem = (AdvItemID, callback) => {
    const data = new FormData();
    data.append("AdvItemID", AdvItemID);
    MyAxios.delete(`Admin_HomeAdv/Item`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("آیتم با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    validate,
    GetHomeAdvs,
    GetAdvByID,
    addAdvBox,
    updateAdvBox,
    deleteAdvBox,
    addAdvItem,
    updateAdvItem,
    deleteAdvItem,
  };
}
